// English translations
export const en = {
  "Purchase Mode": "Purchase Mode",
  "Complete Veranda": "Complete Veranda",
  "Standalone Doors Only": "Standalone Doors Only",
  "Maat": "Size",
  "Uitval Type": "Projection Type",
  "Kleur": "Color",
  "Antraciet": "Anthracite",
  "Creme": "Cream",
  "Zwart": "Black",
  "Dak": "Roof",
  "Zonwering": "Sunshade",
  "Gutter": "Gutter",
  "Voorkant": "Front",
  "Linker": "Left",
  "Rechter": "Right",
  "Breedte": "Width",
  "Uitval": "Projection",
  "Doorloop Hoogte": "Walkthrough Height",
  "Buiten staander": "Outside post",
  "Midden staander": "Middle post",
  "Binnenkant staander": "Inside post",
  "Buitenkant goot": "Outside gutter",
  "Helder - Polycarbonnat": "Clear - Polycarbonate",
  "Opaal - Polycarbonnat": "Opal - Polycarbonate",
  "Zonwerend - Polycarbonnat": "Sun-blocking - Polycarbonate",
  "Glas": "Glass",
  "Getint Glas": "Tinted Glass",
  "Melk Glas": "Milk Glass",
  "Geen": "None",
  "Sandwich paneel": "Sandwich panel",
  "Glazenschuifdeur": "Glass sliding door",
  "Aluminium Schuifdeur": "Aluminum sliding door",
  "Ja": "Yes",
  "Nee": "No",
  "Rond": "Round",
  "Klassiek": "Classic",
  "Vierkant": "Square",
  "Door": "Door",
  "Handle": "Handle",
  "Rechts": "Right",
  "Links": "Left",
  "Place an order": "Place an order",
  "Compare prices": "Compare prices",
  "Loading...": "Loading...",
  "Select": "Select",
  "Lead": "Lead time",
  "Save": "Save",
  "Premium": "Premium",
  "working days": "working days",
  " Spie": "Spie",
  "Wand": "Wall"
};

// Dutch translations (identity, can be expanded)
export const nl = {
  "Purchase Mode": "Aankoop Modus",
  "Complete Veranda": "Volledige Veranda",
  "Standalone Doors Only": "Alleen Losse Deuren",
  "Maat": "Maat",
  "Uitval Type": "Uitval Type",
  "Kleur": "Kleur",
  "Antraciet": "Antraciet",
  "Creme": "Creme",
  "Zwart": "Zwart",
  "Dak": "Dak",
  "Zonwering": "Zonwering",
  "Gutter": "Goot",
  "Voorkant": "Voorkant",
  "Linker": "Linker kant",
  "Rechter": "Rechter kant",
  "Breedte": "Breedte",
  "Uitval": "Uitval",
  "Doorloop Hoogte": "Doorloop Hoogte",
  "Buiten staander": "Buiten staander",
  "Midden staander": "Midden staander",
  "Binnenkant staander": "Binnenkant staander",
  "Buitenkant goot": "Buitenkant goot",
  "Helder - Polycarbonnat": "Helder - Polycarbonnat",
  "Opaal - Polycarbonnat": "Opaal - Polycarbonnat",
  "Zonwerend - Polycarbonnat": "Zonwerend - Polycarbonnat",
  "Glas": "Glas",
  "Getint Glas": "Getint Glas",
  "Melk Glas": "Melk Glas",
  "Geen": "Geen",
  "Sandwich paneel": "Sandwich paneel",
  "Glazenschuifdeur": "Glazenschuifdeur",
  "Aluminium Schuifdeur": "Aluminium Schuifdeur",
  "Ja": "Ja",
  "Nee": "Nee",
  "Rond": "Rond",
  "Klassiek": "Klassiek",
  "Vierkant": "Vierkant",
  "Door": "Door",
  "Handle": "Handle",
  "Rechts": "Rechts",
  "Links": "Links",
  "Place an order": "Bestel nu",
  "Compare prices": "Vergelijk prijzen",
  "Loading...": "Laden...",
  "Select": "Selecteer",
  "Lead": "Levertijd",
  "Save": "Bespaar",
  "Premium": "Premium",
  "working days": "werkdagen",
  " Spie": "Spie",
  "Wand": "Wand"
};

const locales = { en, nl };
let currentLang = localStorage.getItem('lang') || 'en';

export function setLang(lang) {
  if (locales[lang]) {
    currentLang = lang;
    localStorage.setItem('lang', lang);
  }
}

export function t(key) {
  return locales[currentLang][key] || key;
}
